import React from 'react';

import ValueItem from 'components/Widgets/Profile/ValueItem';

import { Link } from 'react-router-dom';
import routes from 'app/routes';

export default function Password() {
  return (

    <ValueItem
      key="password"
      icon="password-icon"
      label="Password"
    >
      <Link
        to={routes.members.profile.password}
        className="btn btn-link"
      >
        Change password
      </Link>
    </ValueItem>

  );
}
